import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import WebinarSessionDateTimeInterface from 'common/types/entities/WebinarSessionDateTimeInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createWebinarSessionDateTime(
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebinarSessionDateTimeInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarSessionDateTime,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    mobilePadding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    fontSize: 18,
    iconFontSize: 20,
  }
}
